import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ModalX from '../../../../shared/ui/elements/Modal-X';
import ExcelExample from './components/ExcelExample';

const WrongFile = ({ open, setOpen }: { open: boolean; setOpen: (value: boolean) => void }) => {
  const { t } = useTranslation('salary-card');

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <ModalX close={() => setOpen(false)} />
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mt={7}>
          <img
            src='/images/digital_account/warning_icon.png'
            alt='non working hour'
            width={64}
            height={64}
          />
          <Typography fontSize={28} lineHeight={1.2} fontWeight={'bold'} align='center' my={3}>
            {t('wrongFile.title')}
          </Typography>
          <Typography fontSize={16} lineHeight={1.4} align='center'>
            {t('wrongFile.description')}
          </Typography>
          <Box mt={4} width={'100%'}>
            <ExcelExample />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WrongFile;
